export type ContactConsentProduct = "loan" | "health"

// Stored with each consent row as proof of the text accepted: bump the version with every change of the checkbox wording
export const CONTACT_CONSENT_WORDING_VERSIONS: Record<ContactConsentProduct, string> = {
    loan: "loan-2026-10",
    health: "health-2026-10",
}

// The single box grants phone, email and the tracking of our emails (open pixel, clicks)
export const contactConsentPayload = (product: ContactConsentProduct, accepted: boolean) => ({
    accept_phone_contact: accepted,
    accept_email_contact: accepted,
    accept_email_tracking: accepted,
    consent_wording_version: CONTACT_CONSENT_WORDING_VERSIONS[product],
})
